"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Help = void 0;
const BFParameters_1 = require("./BFParameters");
class Help {
    constructor(initVal, extras) {
        this.extras = extras;
        this.bfName = initVal.functionCall.name;
        this.bfParameters = Object.keys(initVal.functionCall.parameters).reduce((acc, key) => {
            const val = initVal.functionCall.parameters &&
                initVal.functionCall.parameters[key];
            acc[key] = BFParameters_1.parameterFactory(val, this.extras);
            return acc;
        }, {});
    }
    getHelpVal() {
        const prarameterValues = Object.keys(this.bfParameters).reduce((acc, key) => {
            acc[key] = this.bfParameters[key].getValToEmit();
            return acc;
        }, {});
        return {
            name: this.bfName,
            parameters: prarameterValues,
        };
    }
}
exports.Help = Help;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVscC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvSGVscC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxpREFBa0Q7QUFJbEQsTUFBYSxJQUFJO0lBR2YsWUFBWSxPQUFjLEVBQVMsTUFBYztRQUFkLFdBQU0sR0FBTixNQUFNLENBQVE7UUFDL0MsSUFBSSxDQUFDLE1BQU0sR0FBRyxPQUFPLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQztRQUN4QyxJQUFJLENBQUMsWUFBWSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxVQUFVLENBQUMsQ0FBQyxNQUFNLENBQ3JFLENBQUMsR0FBbUIsRUFBRSxHQUFXLEVBQUUsRUFBRTtZQUNuQyxNQUFNLEdBQUcsR0FDUCxPQUFPLENBQUMsWUFBYSxDQUFDLFVBQVU7Z0JBQ2hDLE9BQU8sQ0FBQyxZQUFhLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQ3hDLEdBQUcsQ0FBQyxHQUFHLENBQUMsR0FBRywrQkFBZ0IsQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQzlDLE9BQU8sR0FBRyxDQUFDO1FBQ2IsQ0FBQyxFQUNELEVBQUUsQ0FDSCxDQUFDO0lBQ0osQ0FBQztJQUNELFVBQVU7UUFDUixNQUFNLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDLE1BQU0sQ0FDNUQsQ0FBQyxHQUFRLEVBQUUsR0FBVyxFQUFFLEVBQUU7WUFDeEIsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQyxZQUFZLENBQUMsR0FBRyxDQUFDLENBQUMsWUFBWSxFQUFFLENBQUM7WUFDakQsT0FBTyxHQUFHLENBQUM7UUFDYixDQUFDLEVBQ0QsRUFBRSxDQUNILENBQUM7UUFDRixPQUFPO1lBQ0wsSUFBSSxFQUFFLElBQUksQ0FBQyxNQUFNO1lBQ2pCLFVBQVUsRUFBRSxnQkFBZ0I7U0FDN0IsQ0FBQztJQUNKLENBQUM7Q0FDRjtBQTdCRCxvQkE2QkMifQ==